import React from 'react';
import PropTypes from 'prop-types';
import Chart from 'chart.js';
import propTypes from 'prop-types';
import { generateColorSpectrum } from './color-data';

const equalArrays = (arr1, arr2) => {
  if(
    (Array.isArray(arr1) && !Array.isArray(arr2)) ||
    (Array.isArray(arr2) && !Array.isArray(arr1)) ||
    arr1.length != arr2.length
  ) {
    return false;
  }

  arr1.sort();
  arr2.sort();

  for(let i = 0; i < arr1.length; i++) {
    if(arr1[i] != arr2[i]) {
      return false;
    }
  }

  return true;
}

class DoughnutChart extends React.Component {
  constructor(props) {
    super(props);

    this.colors;
    this.chart;
    this.labels;
    this.data;
  }

  componentDidMount() {
    if(!this.props.id) {
      throw new Error('Must include an id prop with DoughnutChart component');
    }

    const ctx = $(`#${this.props.id}`);
    this.colors = generateColorSpectrum(this.props.data.length);
    this.labels = this.props.data.map(d => d.label);
    this.data = this.props.data.map(d => d.value);

    this.chart = new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: this.labels,
        datasets: [{
          data: this.data,
          backgroundColor: this.colors
        }]
      },
      options: {
        legend: {
          position: this.props.legend_placement || 'top'
        },
        animation: {
          duration: 2000
        }
      }
    });
  }

  componentDidUpdate() {
    const updated_labels = this.props.data.map(d => d.label);
    const updated_data = this.props.data.map(d => d.value);
    if(!equalArrays(this.labels, updated_labels) || !equalArrays(this.data, updated_data)) {
      this.labels = updated_labels;
      this.data = updated_data;
      this.chart.data.labels = this.labels;
      this.chart.data.datasets = [{
        data: this.data,
        backgroundColor: this.colors
      }];

      this.chart.update();
    }
  }

  render() {
    const style = {
      height: `${this.props.width || 400}px`,
      width: `${this.props.width || 400}px`,
      margin: 'auto'
    };

    return (
      <div
        className={this.props.container_class_name || 'doughnut-chart-container'}
        style={style}
        >
        <canvas id={this.props.id} width={this.props.width || 400} height={this.props.height || 400} />
      </div>
    );
  }
}

DoughnutChart.propTypes = {
  id: propTypes.string,
  data: propTypes.arrayOf(
    propTypes.shape({
      label: propTypes.string,
      value: propTypes.number
    })
  )
};

export default DoughnutChart;



// WEBPACK FOOTER //
// ./src/browser/components/ui/charts/doughnut-chart.js